import React from 'react';
import { NavConfig } from './navigation.types';

import NavItem from './NavItem';
import { useMigrationStatus } from 'shared/custom-hooks/useMigrationStatus';
import { shouldHide } from 'shared/utils/migration-utils';
import { selectSelectedCompany } from 'companies/companies.slice';
import { useSelector } from 'react-redux';
interface NavigationProps {
  navConfig: NavConfig[];
  showLegacy: boolean;
}

function navItemMapper(nav: NavConfig): React.ReactElement {
  let path = nav.path;

  return <NavItem path={path} icon={nav.icon} name={nav.name} key={nav.name} />;
}

function Navigation({ navConfig }: NavigationProps): React.ReactElement {
  const { hasMigrated, status } = useMigrationStatus();
  const selectedCompany = useSelector(selectSelectedCompany);

  const filteredNav = navConfig.filter((nav) => {
    if (nav.hideWhenMigrated) {
      if (shouldHide(status, hasMigrated, nav.hideWhenMigrated, selectedCompany)) {
        return false;
      }
    }

    return true;
  });

  return (
    <nav className="flex flex-col justify-start m-1">
      { filteredNav.map(navItemMapper) }
    </nav>
  );
}

export default Navigation;
